<template>
  <div class="flex items-center min-h-screen w-full flex-col bg-background">
    <header
      v-if="!isStartingPage"
      class="fixed w-[calc(100%-1.5rem)] flex h-16 items-center gap-4 z-50 bg-background/70 backdrop-blur-md rounded-[21px] m-3 p-3"
      :style="{ boxShadow: '0 0 10px 0 rgba(var(--foreground), 0.1)' }"
    >
      <nav class="flex gap-6">
        <StartingLogo />
      </nav>

      <!-- Mobile menu -->
      <!-- <Sheet>
        <SheetTrigger as-child>
          <Button variant="outline" size="icon" class="shrink-0 md:hidden">
            <Menu class="h-5 w-5" />
            <span class="sr-only">Toggle navigation menu</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left">
          <nav class="grid gap-6 text-lg font-medium">
            <a href="/" class="flex items-center gap-2 text-lg font-semibold">
              <Box class="h-6 w-6" />
              <span class="sr-only">XeoVision</span>
            </a>
          </nav>
        </SheetContent>
      </Sheet> -->

      <!-- Right side buttons -->
      <div class="flex grow items-end gap-4 md:ml-auto md:gap-2 lg:gap-4">
        <div class="ml-auto flex items-center sm:space-x-2 md:space-x-4">
          <StartingPageContactButton class="hidden sm:block" v-if="y < 0.6 * height" />
          <!-- <AppLanguageSwitcher /> -->
          <AppActionButtonUser />
          <AppThemeSwitcher />
        </div>
      </div>
    </header>

    <main class="grow" :class="{ 'w-full': isStartingPage }">
      <slot />
    </main>

    <footer v-if="!isStartingPage" class="flex flex-col w-full p-6 md:p-10 h-40 mb-20">
      <div class="container mx-auto">
        <div class="flex flex-col sm:items-start sm:flex-row w-full justify-between">
          <div class="flex flex-col gap-4 items-center sm:items-start">
            <StartingLogo />
            <div class="flex gap-1 justify-center sm:justify-start">
              <a
                href="https://www.linkedin.com/showcase/xeokit/"
                target="_blank"
                class="cursor-pointer"
              >
                <StartingPageIconsLinkedin />
              </a>

              <a href="https://www.youtube.com/@xeokitSDK" target="_blank" class="cursor-pointer">
                <StartingPageIconsYoutube />
              </a>

              <a href="https://github.com/xeokit/xeokit-sdk" target="_blank" class="cursor-pointer">
                <StartingPageIconsGithub />
              </a>
            </div>
          </div>
          <div class="flex flex-col gap-1 items-center sm:items-end">
            <ExoscaleLogo />

            <NuxtLink
              to="https://xeo.vision/privacy-policy/"
              target="_blank"
              class="cursor-pointer font-medium text-sm"
              >{{ $t(`pages.index.footer.privacy`) }}</NuxtLink
            >
            <NuxtLink
              to="https://xeo.vision/terms-and-conditions/"
              target="_blank"
              class="cursor-pointer font-medium text-sm"
              >{{ $t(`pages.index.footer.terms`) }}</NuxtLink
            >
          </div>
        </div>
        <div class="text-xs text-center text-muted-foreground pt-8 sm:pt-0 pb-2">
          &copy; {{ new Date().getFullYear() }} Creoox AG.
          {{ $t(`pages.index.footer.all_rights_reserved`) }}
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { useWindowScroll, useWindowSize } from '@vueuse/core';
import AppActionButtonUser from '~/components/AppActionButtonUser.vue';

const route = useRoute();
const isStartingPage = computed(() => route.path === '/');
const { y } = useWindowScroll();
const { height } = useWindowSize();
</script>
